export default __webpack_public_path__ + "static/media/mentor2.f8c48e24.png";